export const EDITOR_CONSTANTS = {
  CATEGORIES: ['BC', 'GENERAL', 'PORTAL', 'WEBSITE_SERVICE', 'INVOICING_PAYMENT'],
  LANGUAGES: [
    {
      key: 'en',
      name: 'English',
    },
    {
      key: 'de',
      name: 'Deutsch',
    },
    {
      key: 'fi',
      name: 'Finnish',
    },
    {
      key: 'it',
      name: 'Italian',
    },
    {
      key: 'nl',
      name: 'Dutch',
    },
    {
      key: 'tr',
      name: 'Turkish',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/app/content-editor/editor.constant.js